import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type PackageDTO = {
  id: string;
  name: string;
  description: string;
  img_url:string;
  isTrending:boolean;
  actualPrice_egp: string;
  actualPrice_usd: string;
  discountPrice_egp: string;
  discountPrice_usd: string;
  discountPercentage: number;
  courses: Package[];
};
interface Package {
  id: string;
  name: string;
  img_url: string;
  actualPrice_egp: string;
  actualPrice_usd: string;
  discountPrice_egp: string;
  discountPrice_usd: string;
  discountPercentage: number;
}

interface PackagesData {
  pacakgeData: PackageDTO[];
}
interface PackagesResponse {
  data?: PackagesData;
  error?: ApiError;
}

export const GetPackages = async (): Promise<PackagesResponse> => {
  try {
    const response = await axios.get("/package/all");
    return { data: { pacakgeData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
